import { Box, Button, Center, Spinner, Text } from '@chakra-ui/react';
import React from 'react';
import { FiPlusCircle } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

import SearchBar from '../../../components/search-bar';
import { useGetReviewsQuery } from '../../../hooks/useQueries';
import ReviewsTable from './components/reviews-table';
import { styles } from './styles';

const ReviewsList = () => {
  const [filter, setFilter] = React.useState({
    searchString: '',
  });

  const { data: reviews, loading } = useGetReviewsQuery({
    variables: {
      fullName: filter.field,
    },
  });
  const navigate = useNavigate();
  return (
    <Box sx={styles.reviewsListWrapper}>
      <Box sx={styles.headingBar}>
        <Text sx={styles.pageTitle}>Отзывы</Text>
        <Button leftIcon={<FiPlusCircle />} onClick={() => navigate('add')}>
          Добавить отзыв
        </Button>
      </Box>
      <SearchBar placeholder={'Поиск'} onChangeField={setFilter} />

      {loading ? (
        <Center>
          <Spinner
            thickness='0.3vw'
            speed='0.65s'
            emptyColor='gray.200'
            color='blue.200'
            sx={styles.loadingSpinner}
          />
        </Center>
      ) : (
        <ReviewsTable data={reviews?.getReviewsWithCount?.reviews} />
      )}
    </Box>
  );
};

export default ReviewsList;
